import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DeletePinInput_InputAdapter_instancef1q64acype4n as DeletePinInput_InputAdapter_instance } from '../type/adapter/DeletePinInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePinMutation_VariablesAdapterClass;
function DeletePinMutation_VariablesAdapter() {
  if (DeletePinMutation_VariablesAdapterClass === VOID) {
    class $ {
      s6e(writer, value, customScalarAdapters, withDefaultValues) {
        writer.k4a('input');
        obj(DeletePinInput_InputAdapter_instance).t3x(writer, customScalarAdapters, value.r6e_1);
      }
    }
    initMetadataForObject($, 'DeletePinMutation_VariablesAdapter');
    DeletePinMutation_VariablesAdapterClass = $;
  }
  return DeletePinMutation_VariablesAdapterClass;
}
var DeletePinMutation_VariablesAdapter_instance;
function DeletePinMutation_VariablesAdapter_getInstance() {
  return DeletePinMutation_VariablesAdapter_instance;
}
//region block: init
DeletePinMutation_VariablesAdapter_instance = new (DeletePinMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  DeletePinMutation_VariablesAdapter_instance as DeletePinMutation_VariablesAdapter_instance7rhnvtqgucyl,
};
//endregion

//# sourceMappingURL=DeletePinMutation_VariablesAdapter.mjs.map
